export enum ScheduleCalendarMode {
    Day = 1,
    Week = 2, 
    Month = 3
}
